// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"a2547501","223":"59301b96","358":"6ff7d425","390":"531a372b","453":"5c7a3aed","474":"60a6e510","494":"6dfad20d","503":"78756da1","626":"c92cf892","631":"a2236c15","790":"e1b35185","795":"649f55bd","824":"198ef8bb","844":"2c72b282","953":"896bce95"}[chunkId] + ".chunk.js";
};